export default "__VITE_ASSET__9fb9bacd__"